import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';

import { barTornadoChartConfiguration } from './utilities/helpers';

const BarTornadoChart = ({
  onChartCallback = () => {},
  prescriptText = null,
  series,
  xAxis,
  ...props
}) => {
  return (
    <Chart
      onChartCallback={onChartCallback}
      options={merge({}, barTornadoChartConfiguration, {
        series,
        type: 'bar',
        xAxis,
        ...props,
      })}
      prescriptText={prescriptText}
      {...props}
    />
  );
};

BarTornadoChart.propTypes = {
  onChartCallback: PropTypes.func,
  prescriptText: PropTypes.node,
  series: PropTypes.array,
  xAxis: PropTypes.array,
};

export default BarTornadoChart;
